import { createContext, useContext } from "react";
import { useTernaryDarkMode } from "usehooks-ts";

type Props = {
    isDarkMode: boolean;
    toggle: () => void;
    currentMode: TernaryDarkMode;
    set: (mode: TernaryDarkMode) => void;

    isSidebarExpanded: boolean;
    expandSidebar: () => void;
    collapseSidebar: () => void;
    onToggleSidebar: (value: boolean) => void;

    isPlanDetailsOpen: boolean;
    onTogglePlanDetails: () => void;
};

export const DarkModeContext = createContext<Props | null>(null);

export const useAppTheme = () => {
    const context = useContext(DarkModeContext);
    if (!context) {
        throw new Error("useAppTheme must be used within a DarkModeProvider");
    }

    return context;
};

export type TernaryDarkMode = ReturnType<
    typeof useTernaryDarkMode
>["ternaryDarkMode"];
